
import { Component, Prop, Vue } from "vue-property-decorator";

const APP_STORE_URL =
  "https://apps.apple.com/tw/app/%E5%B8%AB%E8%99%8E%E4%BE%86%E4%BA%86/id1495518547";
const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=app.viuto.www.tiger_master&hl=zh_TW&gl=US";

@Component
export default class SitePromoBanner extends Vue {
  @Prop({ default: "join" }) readonly mobileVariant!: "join" | "app";
  @Prop({ default: "/SignUp" }) readonly joinPath!: string;
  @Prop({ default: true }) readonly dismissible!: boolean;

  isVisible = true;

  get appUrl(): string {
    if (typeof navigator === "undefined") return GOOGLE_PLAY_URL;
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    return isIOS ? APP_STORE_URL : GOOGLE_PLAY_URL;
  }

  dismiss(): void {
    this.isVisible = false;
    this.$emit("dismiss");
  }
}
